// Approved Canadian Caprocure identity.
// - lowercase "caprocure" wordmark, navy #0A2540
// - small red Canadian maple leaf glyph (#C8102E) inline with the wordmark
// - thin red underline
// - navy / red / white — restrained, corporate, professional
//
// The `variant="dark"` mode swaps navy → white for use on the navy sidebar
// and the login brand panel.
export default function CaprocureLogo({ variant = "light", size = "md", className = "", showUnderline = true }) {
  const isDark = variant === "dark";
  const wordColor = isDark ? "text-white" : "text-[#0A2540]";
  const underline = isDark ? "bg-white/50" : "bg-[#C8102E]";
  const sizeMap = {
    sm: { word: "text-lg", leaf: 14, gap: "gap-1.5", underlineW: "w-8", underlineH: "h-[2px]" },
    md: { word: "text-xl", leaf: 16, gap: "gap-2", underlineW: "w-10", underlineH: "h-[2px]" },
    lg: { word: "text-3xl", leaf: 22, gap: "gap-2.5", underlineW: "w-14", underlineH: "h-[3px]" },
  };
  const s = sizeMap[size] || sizeMap.md;
  return (
    <div className={`inline-flex flex-col items-start ${className}`} data-testid="caprocure-logo">
      <div className={`inline-flex items-center ${s.gap}`}>
        <span
          className={`font-display font-extrabold lowercase tracking-tight ${wordColor} ${s.word}`}
          style={{ letterSpacing: "-0.02em" }}
        >
          caprocure
        </span>
        <MapleLeaf size={s.leaf} />
        <span className={`text-[10px] font-semibold ${isDark ? "text-white/60" : "text-slate-400"}`} aria-hidden="true">™</span>
      </div>
      {showUnderline && <div className={`mt-1 ${s.underlineW} ${s.underlineH} ${underline} rounded-full`} />}
    </div>
  );
}

export function MapleLeaf({ size = 16, className = "" }) {
  // Simplified stylised Canadian maple leaf. Solid red #C8102E.
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Canadian maple leaf">
      <path
        d="M50 8 L55 30 L72 22 L66 40 L88 40 L74 55 L92 62 L70 66 L74 82 L58 74 L54 92 L50 82 L46 92 L42 74 L26 82 L30 66 L8 62 L26 55 L12 40 L34 40 L28 22 L45 30 Z"
        fill="#C8102E"
      />
    </svg>
  );
}
